<div class="breadcrumb">
  <ng-container *ngFor="let breadcrumb of breadcrumbs">
    <span
      class="breadcrumb__label"
      (click)="breadcrumbClicked(breadcrumb)"
    >
      {{ breadcrumb | translate }}
    </span>
  </ng-container>
</div>
